import React, { useEffect, useState, useRef, useContext } from "react";
import { Badge, Col, Container, Row, Card, Modal, Button } from "react-bootstrap";
import schoolApi from "../../api/schoolApi";
import { useOutletContext, useNavigate } from "react-router-dom";
import moment from "moment";
import "react-calendar/dist/Calendar.css";
import jwt_decode from "jwt-decode";
import { Link } from "react-router-dom";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import * as constants from "../../constants/CONSTANT.jsx";
import { SessionContext } from "../SessionProvider";
// const getPUBLICBASEURL = () => {
//   const tenantCode = sessionStorage?.getItem("schoolcode") ?? "";
//   return `https://crm.idigischool.com/uploads/`;
// };

const getPUBLICBASEURL = () => {
  const tenantCode = sessionStorage?.getItem("schoolcode") ?? "";
   return `https://crm.idigischool.com/uploads/`;
 //return `http://localhost:3000/uploads/`;
};

// Register the required elements
ChartJS.register(ArcElement, Tooltip, Legend);
const Home = (props) => {
  const { selectedSessionId, setSelectedSessionId } = useContext(SessionContext);

  const navigate = useNavigate();
  const prevStudentIdRef = useRef(null);
  const scrollContainerRef = useRef(null);
  const [isHovered, setIsHovered] = useState(false);
  const [selectedTaskForModal, setSelectedTaskForModal] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [transport, setTransport] = useState([]);
  const [studentList, setStudentList] = useState([]);
  const [selectedStudent, setStudent] = useOutletContext();
  console.log("selectedStudent-->>", selectedStudent);
  // const [selectedSessionId, setSessionId] = useState();
  const [studentApi, setStudentApi] = useState(false);
  const [eventList, setEventDetailsList] = useState([]);
 // const [selectedDate, setSelectedDate] = useState(new Date());
 // const [feeData, setFeeData] = useState({});
  const [userInfo , setUserInfo] = useState();
  const [feeCalculator, setFeeCalculator] = useState({
    totalFees: 0,
    lateFee: 0,
    depositedAmount: 0,
    pendingAmount: 0,
  });

  const [attendanceData, setAttendanceData] = useState({
    labels: ["Week 1", "Week 2", "Week 3", "Week 4"],
    datasets: [
      {
        label: "Present Days",
        data: [15, 19, 20, 22],
        backgroundColor: "#f41b35d6",
        borderColor: "#f41b35d6",
        borderWidth: 1,
      },
      {
        label: "Absent Days",
        data: [5, 3, 2, 1],
        backgroundColor: "#ffc107",
        borderColor: "#ffc107",
        borderWidth: 1,
      },
    ],
  });

  const holidayDates = Array.isArray(eventList)
    ? eventList.filter((event) => event.event_type !== null).map((event) => new Date(event.start_date))
    : [];

  // Function to customize calendar tiles
  const tileContent = ({ date, view }) => {
    // Only highlight tiles if the view is monthly
    if (
      view === "month" &&
      holidayDates.some((holiday) => holiday.getTime() === date.getTime())
    ) {
      return <span style={{ color: "red", fontWeight: "bold" }}>•</span>; // or any other indicator you prefer
    }
  };
  const date = new Date();
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  
  // const currentMonthName = monthNames[date.getMonth()];

  useEffect(() => {
    if (selectedStudent?.session_id && selectedStudent.session_id !== selectedSessionId) {
      setSelectedSessionId(selectedStudent.session_id);
    }
  }, [selectedStudent?.session_id, selectedSessionId]);

  useEffect(() => {
    if (selectedStudent?.id && selectedSessionId) {
      fetchStudentDetails();
    }
  }, [selectedStudent?.id, selectedSessionId]);

  async function fetchStudentDetails() {
    try {      
      if (selectedStudent ) { // && prevStudentIdRef.current !== selectedStudent.id
        let studentDetails = await schoolApi.fetchStudentsById(selectedStudent.id, selectedSessionId);
        console.log("studentDetails32233==>", studentDetails);

        if (studentDetails.success) {
          const sessionToUse =
            selectedSessionId || studentDetails?.studentRec?.session_id;
          if (!selectedSessionId && studentDetails?.studentRec?.session_id) {
            setSelectedSessionId(studentDetails.studentRec.session_id);
          }

          let feeResult = await schoolApi.getStudentFeeIntsallmentRecords(
            studentDetails?.studentRec?.student_addmission_id,
            sessionToUse
          );

          console.log("feeResult-->>", feeResult);
          if (feeResult.result && Array.isArray(feeResult.result)) {
            let totalFees = 0;
            let lateFee = 0;
            let depositedAmount = 0;
            let totalDiscount = 0;

            feeResult.result.forEach((element) => {
              totalFees += (element.installment_amount || 0) + (element.transport_fee || 0);
              depositedAmount += (element.deposited_amount || 0);
              lateFee += (element.late_fee || 0);
              totalDiscount += (element.installment_discount || 0);
            });

            setFeeCalculator({
              totalFees: totalFees,
              lateFee: lateFee,
              depositedAmount: depositedAmount,
              pendingAmount: totalFees - depositedAmount - totalDiscount,
            });
          } else {
            setFeeCalculator({
              totalFees: 0,
              lateFee: 0,
              depositedAmount: 0,
              pendingAmount: 0,
            });
          }
        // }
        }

        prevStudentIdRef.current = selectedStudent.id;

        // 19-Feb-2025 | sarfraj
        let data = await schoolApi.getAssignTransportByIdOrStudentid(
          // selectedStudent.addmission_id ? selectedStudent.addmission_id : selectedStudent.student_addmission_id,
          // selectedStudent.addmission_id ? selectedStudent.addmission_id : studentDetails?.studentRec.student_addmission_id,
          // selectedStudent?.id,
          studentDetails?.studentRec?.id,
          selectedSessionId,
        );
        
        if(data.success && data.result.status){
          setTransport(data?.result);
        } else {
          setTransport([]);
        }

        if (studentDetails && studentDetails.success && studentDetails?.studentRec) {
          setStudentList(studentDetails?.studentRec);
          setStudentApi(true);
        } else {
          setStudentList([]);
        }
      }

      if (selectedStudent) {
        let eventsDetails = await schoolApi.fetchEvents();
        if (eventsDetails) {
          setEventDetailsList(eventsDetails);
          setStudentApi(true);
        } else {
          setEventDetailsList([]);
        }
      }
    } catch (error) {
      // console.error("Error fetching Events Details:", error);
      console.log("Error fetching Events Details:", error);
      setStudentList([]);
      setStudentApi(true);
      setFeeCalculator({
        totalFees: 0,
        lateFee: 0,
        depositedAmount: 0,
        pendingAmount: 0,
      });
      setTransport(null);
      if (error?.response?.status === 401) {
        navigate("/login");
      }
    }
  }

  const [approvedTasks, setApprovedTasks] = useState([]);

  const isImage = (fileName) => fileName && /\.(jpg|jpeg|png|gif|webp)$/i.test(fileName);
  const isVideo = (fileName) => fileName && /\.(mp4|webm|ogg)$/i.test(fileName);

  useEffect(() => {
    try {
      const token = sessionStorage.getItem("token");
      const decodedToken = jwt_decode(token);
      if(decodedToken){
        setUserInfo(decodedToken);
      }
    } catch (error) {
      console.log('error-->>' , error);
    }
  }, [])

  const [mediaMap, setMediaMap] = useState({});

  useEffect(() => {
    const getApprovedTasks = async () => {
      try {
        const result = await schoolApi.fetchApprovedTasks();
        if (result && result.success) {
          setApprovedTasks(result.result);

          // Fetch media for each task
          const newMediaMap = {};
          for (const task of result.result) {
            const approvedSub = task.assigned_users?.find(u => u.status === 'Approved');
            if (approvedSub?.file_id && (isImage(approvedSub.file_title) || isVideo(approvedSub.file_title))) {
              try {
                const blob = await schoolApi.downloadFiles(approvedSub.file_id);
                newMediaMap[approvedSub.file_id] = URL.createObjectURL(blob);
              } catch (err) {
                console.error("Error loading media:", err);
              }
            }
          }
          setMediaMap(newMediaMap);
        }
      } catch (err) {
        console.error("Error fetching tasks:", err);
      }
    };
    getApprovedTasks();

    return () => {
      // Clean up blob URLs
      Object.values(mediaMap).forEach(url => URL.revokeObjectURL(url));
    };
  }, []);

  useEffect(() => {
    const container = scrollContainerRef.current;
    if (!container) return;

    let scrollInterval;
    const startScrolling = () => {
      scrollInterval = setInterval(() => {
        if (container.scrollTop + container.clientHeight >= container.scrollHeight - 1) {
          container.scrollTop = 0;
        } else {
          container.scrollTop += 1;
        }
      }, 40);
    };

    if (!isHovered && approvedTasks?.length > 2) {
      startScrolling();
    }

    return () => clearInterval(scrollInterval);
  }, [isHovered, approvedTasks]);

  console.log('userInfo@@===>>>', userInfo);

  return (
    <>
      {studentApi ? (
        <Container className="container-style">
          <Row>
            <Col lg={3} md={6} sm={12} className="mb-1">
              <Card className="p-3 shadow-sm h-100">
                <Card.Body className="text-center">
                  <Card.Title className="mb-3">
                    <b className="studentnamestyle">{userInfo ? userInfo.firstname + " " + userInfo.lastname : ""}</b>
                  </Card.Title>
                  {
                    // userInfo.file_parent_id && userInfo.file_id ? (
                    selectedStudent.file_parent_id && selectedStudent.file_id ? (
                    <img
                      // src={`${getPUBLICBASEURL()}${userInfo.file_parent_id}/${userInfo.file_id}.${userInfo.file_type}`}
                      src={`${getPUBLICBASEURL()}${selectedStudent.file_parent_id}/${selectedStudent.file_id}.${selectedStudent.filetype}`}
                      alt="profile"
                      className="student-profile-picture img-fluid rounded-circle mt-2"
                    />
                  ) : (
                    <img
                      src={`${getPUBLICBASEURL()}dwps_ajmer/image_2024102442318.png`}
                      alt="dummy_profile"
                      className="img-fluid rounded-circle"
                      style={{
                        height: "120px",
                        width: "120px",
                        objectFit: "cover",
                        border: "2px solid #ddd",
                      }}
                    />
                  )}
                </Card.Body>
              </Card>
            </Col>

            <Col lg={9}>
              <Card className="p-3 shadow-sm">
                <Card.Title className="mb-3 d-flex align-items-center">
                  <i className="fa-solid fa-user fa-lg me-2 text-primary"></i>
                  <b className="stu-header">Personal Information</b>
                </Card.Title>
                <Card.Body>
                  <Row className="view-form gy-2">
                    <Col lg={6} md={12} sm={12}>
                      <b>Parent Name</b>
                      <span className="form-value">
                        {selectedStudent.parentname || "N/A"}
                      </span>
                    </Col>
                    <Col lg={6} md={12} sm={12}>
                      <b>Parent Phone</b>
                      <span className="form-value">
                        {selectedStudent.contactphone || "N/A"}
                      </span>
                    </Col>
                    <Col lg={6} md={12} sm={12}>
                      <b>Student Phone</b>
                      <span className="form-value">
                        {studentList.phone || "N/A"}
                      </span>
                    </Col>
                    <Col lg={6} md={12} sm={12}>
                      <b>Email</b>
                      <span className="form-value">
                        {studentList.email || "N/A"}
                      </span>
                    </Col>
                    <Col lg={6} md={12} sm={12}>
                      <b>Gender</b>
                      <span className="form-value">
                        {studentList.gender || "N/A"}
                      </span>
                    </Col>
                    <Col lg={6} md={12} sm={12}>
                      <b>Date of Birth</b>
                      <span className="form-value">
                        {studentList.dateofbirth ? moment(studentList.dateofbirth).format("DD-MM-YYYY") : "N/A"}
                      </span>
                    </Col>
                    <Col lg={6} md={12} sm={12}>
                      <b>Aadhaar Number</b>
                      <span className="form-value">
                        {studentList.adharnumber || "N/A"}
                      </span>
                    </Col>
                    <Col lg={6} md={12} sm={12}>
                      <b>Religion</b>
                      <span className="form-value">
                        {studentList.religion || "N/A"}
                      </span>
                    </Col>
                    <Col lg={6} md={12} sm={12}>
                      <b>Street</b>
                      <span className="form-value">
                        {studentList.street || "N/A"}
                      </span>
                    </Col>
                    <Col lg={6} md={12} sm={12}>
                      <b>City</b>
                      <span className="form-value">
                        {studentList.city || "N/A"}
                      </span>
                    </Col>
                    <Col lg={6} md={12} sm={12}>
                      <b>State</b>
                      <span className="form-value">
                        {studentList.state || "N/A"}
                      </span>
                    </Col>
                    <Col lg={6} md={12} sm={12}>
                      <b>Country</b>
                      <span className="form-value">
                        {studentList.country || "N/A"}
                      </span>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          {console.log("feeCalculator--?>", feeCalculator)}
          <Row className="mt-3">
            <Col lg={12}>
              <Card>
                <Card.Body>
                  <Card.Title>
                    <i className="fa-solid fa fa-bank fa-lg m-2"></i>
                    <b className="stu-header">Fee Information</b>
                  </Card.Title>
                  <Row>
                    <Col md={6} lg={3}>
                      <Link className="text-decoration-none text-reset">
                        <div
                          className="p-2 d-flex flex-column align-items-center m-2"
                          style={{
                            backgroundColor: "white",
                            borderLeft: "4px solid tomato",
                            borderRadius: "8px",
                          }}
                        >
                          <span className="fa-stack small mb-2">
                            <i
                              className="fa-solid fa-circle fa-stack-2x"
                              style={{ color: "tomato" }}
                            ></i>
                            <i
                              className="fa-solid fa fa-inr fa-stack-1x"
                              style={{ color: "white", fontSize: "1.5rem" }}
                            ></i>
                          </span>
                          <div className="flex-grow-1 text-center">
                            <h6 className="text-muted mb-1 small">
                              <b>TOTAL FEE</b>
                            </h6>
                            <h1
                              className="mb-0 d-inline"
                              style={{ fontSize: "1.5rem" }}
                            >
                              {feeCalculator.totalFees}
                            </h1>
                            <Badge
                              bg="light"
                              text="dark"
                              className="small mt-2"
                            >
                              AVAILABLE
                            </Badge>
                          </div>
                        </div>
                      </Link>
                    </Col>
                    <Col md={6} lg={3}>
                      <Link className="text-decoration-none text-reset">
                        <div
                          className="p-2 d-flex flex-column align-items-center m-2"
                          style={{
                            backgroundColor: "white",
                            borderLeft: "4px solid #1a293b",
                            borderRadius: "8px",
                          }}
                        >
                          <span className="fa-stack small mb-2">
                            <i
                              className="fa-solid fa-circle fa-stack-2x"
                              style={{ color: "green" }}
                            ></i>
                            <i
                              className="fas fa-money-check fa-stack-1x"
                              style={{ color: "white", fontSize: "1.5rem" }}
                            ></i>
                          </span>
                          <div className="flex-grow-1 text-center">
                            <h6 className="text-muted mb-1 small">
                              <b>AMOUNT PAID</b>
                            </h6>
                            <h1
                              className="mb-0 d-inline"
                              style={{ fontSize: "1.5rem" }}
                            >
                              {feeCalculator.depositedAmount}
                            </h1>
                            <Badge
                              bg="light"
                              text="dark"
                              className="small mt-2"
                            >
                              AVAILABLE
                            </Badge>
                          </div>
                        </div>
                      </Link>
                    </Col>
                    <Col md={6} lg={3}>
                      <Link className="text-decoration-none text-reset">
                        <div
                          className="p-2 d-flex flex-column align-items-center m-2"
                          style={{
                            backgroundColor: "white",
                            borderLeft: "4px solid #4798b5",
                            borderRadius: "8px",
                          }}
                        >
                          <span className="fa-stack small mb-2">
                            <i
                              className="fa-solid fa-circle fa-stack-2x"
                              style={{ color: "red" }}
                            ></i>
                            <i
                              className="fa-solid fa-hand-holding-dollar fa-stack-1x"
                              style={{ color: "white", fontSize: "1.5rem" }}
                            ></i>
                          </span>
                          <div className="flex-grow-1 text-center">
                            <h6 className="text-muted mb-1 small">
                              <b>LATE FEE</b>
                            </h6>
                            <h1
                              className="mb-0 d-inline"
                              style={{ fontSize: "1.5rem" }}
                            >
                              {feeCalculator.lateFee}
                            </h1>{" "}
                            <Badge
                              bg="light"
                              text="dark"
                              className="small mt-2"
                            >
                              Running
                            </Badge>
                          </div>
                        </div>
                      </Link>
                    </Col>
                    <Col md={6} lg={3}>
                      <Link className="text-decoration-none text-reset">
                        <div
                          className="p-2 d-flex flex-column align-items-center m-2"
                          style={{
                            backgroundColor: "white",
                            borderLeft: "4px solid #4798b5",
                            borderRadius: "8px",
                          }}
                        >
                          <span className="fa-stack small mb-2">
                            <i
                              className="fa-solid fa-circle fa-stack-2x "
                              style={{ color: "purple" }}
                            ></i>
                            <i
                              className="fa-solid fa fa-bank fa-stack-1x"
                              style={{ color: "white", fontSize: "1.5rem" }}
                            ></i>
                          </span>
                          <div className="flex-grow-1 text-center">
                            <h6 className="text-muted mb-1 small">
                              <b>REMAINING AMOUNT</b>
                            </h6>
                            <h1
                              className="mb-0 d-inline"
                              style={{ fontSize: "1.5rem" }}
                            >
                              {feeCalculator.pendingAmount}
                            </h1>{" "}
                            <Badge
                              bg="light"
                              text="dark"
                              className="small mt-2"
                            >
                              Running
                            </Badge>
                          </div>
                        </div>
                      </Link>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <Row className="mt-3">
            {/* Vehicle Information Card */}
            <Col lg={3} md={6} sm={12} className="mb-3">
              <Card className="p-3 shadow-sm h-100">
                <Card.Body>
                  <Card.Title className="d-flex align-items-center">
                    <i className="fa-solid fa-bus fa-lg me-2"></i>
                    <b className="stu-header">Vehicle Information</b>
                  </Card.Title>
                  {transport?.driver_name &&
                  transport?.driver_phone &&
                  transport?.vehicle_no &&
                  transport?.location_name ? (
                    <Row className="view-form mt-3 gy-2">
                      <Col lg={12}>
                        <b>Driver Name</b>
                        <span>{transport?.driver_name}</span>
                      </Col>
                      <Col lg={12}>
                        <b>Driver Phone</b>
                        <span>{transport?.driver_phone}</span>
                      </Col>
                      <Col lg={12}>
                        <b>Vehicle Number</b>
                        <span>{transport?.vehicle_no}</span>
                      </Col>
                      <Col lg={12}>
                        <b>Vehicle Route</b>
                        <span>{transport?.location_name}</span>
                      </Col>
                    </Row>
                  ) : (
                    <>
                      <p>Vehicle record not available</p>
                    </>
                  )}
                </Card.Body>
              </Card>
            </Col>

            {/* Academic Information Card */}
            <Col lg={6} md={6} sm={12} className="mb-3">
              <Card className="academic-card shadow-sm rounded p-3">
                <Card.Body>
                  <Card.Title className="d-flex align-items-center mb-3">
                    <i className="fa-solid fa-user-graduate fa-lg me-2 text-primary"></i>
                    <b className="stu-header">Academic Information</b>
                  </Card.Title>
                  <Row className="view-form gy-1">
                    <Col lg={6}>
                      <b>Class Name</b>
                      <span className="form-value">
                        {studentList.classname || "N/A"}
                      </span>
                    </Col>
                    <Col lg={6}>
                      <b>Section Name</b>
                      <span className="form-value">
                        {studentList.section || "N/A"}
                      </span>
                    </Col>
                    <Col lg={6}>
                      <b>RTE</b>
                      <span className="form-value">
                        {studentList.isrte ? "Yes" : "No"}
                      </span>
                    </Col>
                    <Col lg={6}>
                      <b>Sr No.</b>
                      <span className="form-value">
                        {studentList.srno || "N/A"}
                      </span>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>

              {/* Showcase Tasks Card */}
              {approvedTasks?.length > 0 && (
                <Card className="showcase-card shadow-sm rounded-4 p-3 mb-3 border-0" style={{ background: '#ffffff' }}>
                  <Card.Body className="p-2">
                    <Card.Title className="d-flex align-items-center mb-4 justify-content-between">
                      <div className="d-flex align-items-center">
                        <div className="bg-danger bg-opacity-10 p-2 rounded-circle me-3 d-flex align-items-center justify-content-center" style={{ width: '40px', height: '40px' }}>
                          <i className="fa-brands fa-youtube fs-4 text-danger"></i>
                        </div>
                        <div>
                          <b className="stu-header m-0 fs-5 text-dark d-block">Task Feed</b>
                          <small className="text-muted">Latest approved submissions</small>
                        </div>
                      </div>
                    </Card.Title>

                    <style>
                      {`
                        .custom-scrollbar::-webkit-scrollbar {
                          width: 6px;
                        }
                        .custom-scrollbar::-webkit-scrollbar-track {
                          background: transparent; 
                        }
                        .custom-scrollbar::-webkit-scrollbar-thumb {
                          background: #d1d5db; 
                          border-radius: 10px;
                        }
                        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
                          background: #9ca3af; 
                        }
                        .yt-card {
                          transition: background-color 0.2s ease;
                        }
                        .yt-card:hover {
                          background-color: #f3f4f6;
                          border-radius: 12px;
                        }
                      `}
                    </style>

                    <div
                      ref={scrollContainerRef}
                      className="custom-scrollbar pe-2"
                      style={{ maxHeight: '340px', overflowY: 'auto' }}
                      onMouseEnter={() => setIsHovered(true)}
                      onMouseLeave={() => setIsHovered(false)}
                    >
                      <div className="d-flex flex-column gap-2">
                        {approvedTasks.map((task, index) => {
                          const approvedSub = task.assigned_users?.find(u => u.status === 'Approved');
                          if (!approvedSub) return null;

                          const mediaUrl = mediaMap[approvedSub.file_id];

                          return (
                            <div key={index} className="yt-card p-2" onClick={() => {
                              setSelectedTaskForModal({ task, approvedSub, mediaUrl });
                              setShowModal(true);
                            }}>
                              <Row className="g-3">
                                {approvedSub.file_id && (
                                  <Col xs={12} sm={5} md={5} lg={5} className="position-relative">
                                    <div className="rounded-3 overflow-hidden shadow-sm" style={{ aspectRatio: '16/9', backgroundColor: '#e5e7eb', position: 'relative' }}>
                                      {mediaUrl ? (
                                        isImage(approvedSub.file_title) ? (
                                          <img
                                            src={mediaUrl}
                                            alt={task.title}
                                            className="w-100 h-100"
                                            style={{ position: 'absolute', top: 0, left: 0, objectFit: 'cover' }}
                                          />
                                        ) : isVideo(approvedSub.file_title) ? (
                                          <>
                                            <video
                                              src={mediaUrl}
                                              className="w-100 h-100"
                                              style={{ position: 'absolute', top: 0, left: 0, objectFit: 'cover' }}
                                            />
                                            <div className="position-absolute top-50 start-50 translate-middle text-white bg-dark bg-opacity-75 rounded-circle d-flex align-items-center justify-content-center" style={{ width: '40px', height: '40px', zIndex: 2 }}>
                                              <i className="fa-solid fa-play"></i>
                                            </div>
                                          </>
                                        ) : (
                                          <div className="d-flex flex-column align-items-center justify-content-center h-100 text-muted">
                                            <i className="fa-solid fa-file-pdf fs-2 mb-2 text-danger"></i>
                                            <span className="small fw-medium">Document</span>
                                          </div>
                                        )
                                      ) : (
                                        <div className="d-flex align-items-center justify-content-center h-100">
                                          <div className="spinner-border spinner-border-sm text-secondary" role="status"></div>
                                        </div>
                                      )}

                                      {/* Duration / Format badge like YouTube */}
                                      {approvedSub.file_title && (
                                        <div className="position-absolute bottom-0 end-0 m-1 px-1 rounded text-white" style={{ backgroundColor: 'rgba(0,0,0,0.7)', fontSize: '0.7rem', fontWeight: '500' }}>
                                          {isVideo(approvedSub.file_title) ? 'VIDEO' : isImage(approvedSub.file_title) ? 'IMAGE' : 'FILE'}
                                        </div>
                                      )}
                                    </div>
                                  </Col>
                                )}
                                <Col xs={12} sm={approvedSub.file_id ? 7 : 12} md={approvedSub.file_id ? 7 : 12} lg={approvedSub.file_id ? 7 : 12}>
                                  <div className="d-flex flex-column h-100 py-1">
                                    <h6 className="fw-bold text-dark mb-1" style={{ fontSize: '1rem', lineHeight: '1.4', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                                      {task.title}
                                    </h6>
                                    {task.description && (
                                      <div
                                        className="text-dark mb-2"
                                        style={{ fontSize: '0.85rem', lineHeight: '1.4', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}
                                        dangerouslySetInnerHTML={{ __html: task.description }}
                                      />
                                    )}

                                    {/* <div
                                      className="text-secondary mb-2"
                                      style={{ fontSize: '0.85rem', lineHeight: '1.4', color: '#6b7280', display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical', overflow: 'hidden', borderLeft: '3px solid #e5e7eb', paddingLeft: '8px' }}
                                      dangerouslySetInnerHTML={{ __html: approvedSub.description }}
                                    /> */}
                                    {/* 
                                    {approvedSub.admin_comment && (
                                      <div className="mt-auto pt-1">
                                        <Badge bg="success" className="bg-opacity-10 text-success fw-normal border border-success border-opacity-25" style={{ fontSize: '0.75rem' }}>
                                          <i className="fa-solid fa-comment-dots me-1"></i> {approvedSub.admin_comment}
                                        </Badge>
                                      </div>
                                    )} */}
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              )}

              {/* Other Information Card */}
              <Card className="other-info-card shadow-sm rounded p-3 mt-3">
                <Card.Body>
                  <Card.Title className="d-flex align-items-center mb-3">
                    <i className="fa fa-university fa-lg me-2 text-primary"></i>
                    <b className="stu-header">Other Information</b>
                  </Card.Title>
                  <Row className="view-form gy-1">
                    <Col lg={6}>
                      <b>Category</b>
                      <span className="form-value">
                        {studentList.category || "N/A"}
                      </span>
                    </Col>
                    <Col lg={6}>
                      <b>Permanent Street</b>
                      <span className="form-value">
                        {studentList.permanentstreet || "N/A"}
                      </span>
                    </Col>
                    <Col lg={6}>
                      <b>Permanent City</b>
                      <span className="form-value">
                        {studentList.permanentcity || "N/A"}
                      </span>
                    </Col>
                    <Col lg={6}>
                      <b>Permanent State</b>
                      <span className="form-value">
                        {studentList.permanentstate || "N/A"}
                      </span>
                    </Col>
                    <Col lg={6}>
                      <b>Permanent Country</b>
                      <span className="form-value">
                        {studentList.permanentcountry || "N/A"}
                      </span>
                    </Col>
                    <Col lg={6}>
                      <b>Pincode</b>
                      <span className="form-value">
                        {studentList.pincode || "N/A"}
                      </span>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>

            {/* Events Information Card */}
            <Col lg={3} md={6} sm={12} className="mb-3">
              <Card className="p-3 shadow-sm h-100">
                <Card.Body>
                  <Card.Title className="d-flex align-items-center">
                    <i className="fa fa-calendar fa-lg me-2"></i>
                    <b className="stu-header">Events Information</b>
                  </Card.Title>
                  <div className="marquee-vertical mt-3">
                    {eventList?.length > 0 ? (
                      <ul className="marquee-list">
                        {eventList?.map((event, index) => (
                          <li key={index} className="marquee-item">
                            <strong>
                              <i className="fa fa-arrow-right fa-lg me-2"></i>
                              {event.title}
                            </strong>
                            <br />
                            Type: {event.event_type}
                            <br />
                            Date:{" "}
                            {moment(event.start_date).format(
                              "DD MMMM YYYY"
                            )} to{" "}
                            {moment(event.end_date).format("DD MMMM YYYY")}
                            <br />
                            Time:{" "}
                            {moment(event.start_time, "HH:mm:ss").format(
                              "hh:mm A"
                            )}{" "}
                            to{" "}
                            {moment(event.end_time, "HH:mm:ss").format(
                              "hh:mm A"
                            )}
                            <br />
                            Description: {event.description}
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <p className="text-muted">No events available</p>
                    )}
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      ) : (
        <Container>
          <Col lg={12}>
            {/* <Card className="homeCardStyle">
              <Card.Body className="text-center">
                <Image
                  variant="top"
                  src="/comonLogoSchool.png"
                  className="rounded-circle text-center"
                  thumbnail
                  style={{ width: "100px", height: "100px" }}
                ></Image>
                <Card.Title className="mt-3">
                  Welcome to {authTokenDecoded.tenantcode} Portal
                </Card.Title>
              </Card.Body>
            </Card> */}
          </Col>
        </Container>
      )}
      {/* Task Attachment Details Modal */}
      {selectedTaskForModal && (
        <Modal 
          show={showModal} 
          onHide={() => setShowModal(false)} 
          size="lg" 
          centered
          className="task-detail-modal"
        >
          <Modal.Header closeButton className="border-0 pb-0">
            <Modal.Title className="fw-bold text-dark fs-5">
              {selectedTaskForModal.task.title}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="pt-2">
            <div className="d-flex flex-column gap-3">
              {/* Media viewer */}
              {selectedTaskForModal.approvedSub.file_id && (
                <div className="rounded-3 overflow-hidden bg-black d-flex align-items-center justify-content-center border" style={{ maxHeight: '500px', minHeight: '300px', position: 'relative' }}>
                  {selectedTaskForModal.mediaUrl ? (
                    isImage(selectedTaskForModal.approvedSub.file_title) ? (
                      <img 
                        src={selectedTaskForModal.mediaUrl} 
                        alt="attachment" 
                        className="img-fluid" 
                        style={{ maxHeight: '500px', objectFit: 'contain' }} 
                      />
                    ) : isVideo(selectedTaskForModal.approvedSub.file_title) ? (
                      <video 
                        src={selectedTaskForModal.mediaUrl} 
                        controls 
                        autoPlay 
                        className="w-100" 
                        style={{ maxHeight: '500px' }} 
                      />
                    ) : (
                      <div className="text-center p-5 text-white">
                        <i className="fa-solid fa-file-pdf fs-1 mb-3 text-danger"></i>
                        <h5>{selectedTaskForModal.approvedSub.file_title}</h5>
                        <p className="text-muted small">This document format is not previewable in-browser. Please download it using the button below.</p>
                      </div>
                    )
                  ) : (
                    <div className="text-center py-5 text-white">
                      <div className="spinner-border text-light" role="status"></div>
                    </div>
                  )}
                </div>
              )}

              {/* Task descriptions */}
              <div className="px-1">

                {/* Main Task Description */}
                {selectedTaskForModal.task.description && (
                  <div className="mb-3">
                    <h6 className="fw-bold text-dark mb-1">Task Requirements</h6>
                    <div 
                      className="text-secondary" 
                      style={{ fontSize: '0.9rem', lineHeight: '1.5' }}
                      dangerouslySetInnerHTML={{ __html: selectedTaskForModal.task.description }}
                    />
                  </div>
                )}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="border-0 pt-0">
            {selectedTaskForModal.mediaUrl && (
              <a 
                href={selectedTaskForModal.mediaUrl} 
                download={selectedTaskForModal.approvedSub.file_title || 'attachment'} 
                className="btn btn-primary d-flex align-items-center gap-2"
              >
                <i className="fa-solid fa-download"></i> Download Attachment
              </a>
            )}
            <Button variant="secondary" onClick={() => setShowModal(false)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
};

export default Home;
